export default {
  my_name_not_login: "快速登入",
  my_good_record: "保持良好借還紀錄,享提高額度",
  my_cell_list_help: "幫助中心",
  my_cell_list_info: "我的資料",
  my_cell_list_customer: "我的客服",
  my_cell_list_privacy: "隱私協定",
  my_cell_list_myinfo: "個人資料",
  my_cell_list_setting: "設定",
  my_help_produce_title: "聯絡客服",
  my_help_loan_issue: "貸款問題",
  my_help_release_issue: "放款問題",
  my_help_repay_issue: "還款問題",
  my_setting_logout_btn: "退出登入",
  my_setting_logout_title: "提示",
  my_setting_logout_message: "確認退出？",
  my_setting_logout_msg: "確認已登出嗎？",
  my_setting_close: "關閉",
  my_setting_phone_cust: "電話客服",
  my_setting_zalo_cust: "聯絡Zalo客服",
  my_setting_line_cust: "聯絡LINE",
  my_setting__code_zalo_cust: "二維碼添加",
  my_setting_zalo_code_cust: "掃碼添加LINE",
  my_setting_zalo_dowl_cust: "下載二維碼圖片,用LINE掃描添加",
  my_setting_zalo_close_cust: "關閉",
  my_setting_zalo_save_cust: "下載圖片",
  my_setting_facebook_cust: "聯絡Facebook客服",
  my_setting_logout_toast: "退出登入成功",
  not_fount_h3: "您造訪的頁面不存在",
  not_fount_cause: "可能原因",
  not_fount_cause1: "1. 網路不穩定",
  not_fount_cause2: "2. 尚未上網",
  not_fount_cause3: "3. 安全軟體禁止存取網路",
  my_cancel_btn: "取消",
  my_confirm_btn: "確定"
}